module.exports = __webpack_public_path__ + "static/media/watermelon.426c7853.png";